import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDuplicate = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 28,
	height: 28,
	viewBox: "0 0 28 28",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-hidden": "true",
	focusable: "false",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Copy",
		children: [/* @__PURE__ */ _jsx("path", {
			id: "Vector",
			d: "M18.375 18.375H23.625V4.375H9.625V9.625",
			stroke: "#846701",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}), /* @__PURE__ */ _jsx("path", {
			id: "Vector_2",
			d: "M18.375 9.625H4.375V23.625H18.375V9.625Z",
			stroke: "#846701",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})]
	})
});
export default SvgDuplicate;
